import HeaderPortal from "components/portal/header-portal";
import List from "components/list";
import React from "react";
import { useParams } from "react-router-dom";
import { Button } from "ui/index";
import CreateItemButton from "components/buttons/create";
import { PermissionGate } from "permissions/components/gate";
import BookmarkDialog from "./input";
import { useProject } from "../context";
import { useUpdateBookmarkFolder } from "./mutation";
import { EmptySection1 } from "components/empty";
import { Link } from "react-router-dom";

export default function ProjectBookmarks() {
  const { project_slug } = useParams();
  const { id, bookmark_folder } = useProject();
  const { mutateAsync: updateFolder, isPending: isUpdatingFolder } =
    useUpdateBookmarkFolder();
  const handleCreateFolder = async () => {
    const payload = {
      bookmark_folder: {
        name: project_slug,
      },
    };
    await updateFolder({ projectId: id, item: payload });
  };

  const fields = ["id", "label", "description", "url", "bookmark"];

  const columns = [
    {
      id: "url",
      accessorKey: "url",
      cell: ({ row }) => {
        const url = row.getValue("url");
        let domain;
        try {
          domain = new URL(url).hostname;
        } catch {
          domain = null;
        }

        return (
          <div className="w-4">
            <img
              src={`https://www.google.com/s2/favicons?domain=${domain}&sz=32`}
              alt=""
              className="w-4 h-4"
              onError={(e) => {
                e.currentTarget.src = "/default-favicon.png";
              }}
            />
          </div>
        );
      },
    },
    {
      id: "label",
      accessorKey: "label",
      cell: ({ row }) => {
        const label = row.getValue("label");
        return (
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm">{label}</span>
          </div>
        );
      },
    },
    {
      id: "url",
      accessorKey: "url",
      cell: ({ getValue }) => {
        const url = getValue();
        return (
          <div
            className="hover:underline text-muted-foreground cursor-pointer"
            onClick={() => window.open(url, "_blank")}
          >
            {url}
          </div>
        );
      },
    },
    {
      id: "id",
      accessorKey: "id",
      cell: ({ getValue }) => {
        return (
          <div>
            <PermissionGate
              rule="create:PC"
              collection="bookmark_links"
              showWhenDisabled={false}
            >
              <Link
                to={`/work/projects/${project_slug}/bookmarks/${getValue()}`}
              >
                <Button variant="ghost">Edit</Button>
              </Link>
            </PermissionGate>
          </div>
        );
      },
    },
  ];

  const defaultFilters = {
    bookmark: {
      project: { _eq: id },
    },
  };

  return (
    <div className="flex-1 overflow-auto">
      {!bookmark_folder ? (
        <div className="py-3">
          <EmptySection1
            children={
              <PermissionGate
                rule="update:PC"
                collection="projects"
                fallback={
                  <div className="text-muted-foreground text-sm">
                    Ask project coordinator to create a bookmark folder
                  </div>
                }
              >
                <Button onClick={handleCreateFolder}>Create</Button>
              </PermissionGate>
            }
          />
        </div>
      ) : (
        <div>
          <HeaderPortal>
            <PermissionGate
              rule="create:PC,JC"
              collection="bookmark_links"
              showWhenDisabled={false}
            >
              <CreateItemButton
                href={`/work/projects/${project_slug}/bookmarks/+`}
              >
                Add
              </CreateItemButton>
            </PermissionGate>
          </HeaderPortal>
          <List
            title="Bookmarks"
            endPoint="bookmark_links"
            storageKey={project_slug}
            filters={defaultFilters}
            columns={columns}
            // hidePagination={true}
            showSearch={false}
            showHeader={false}
            meta={{ fields }}
            perPage={25}
          />
          {/* Always render the BookmarkDialog - it will handle showing/hiding the dialog */}
          <BookmarkDialog
            bookmark_folder={bookmark_folder}
            project_slug={project_slug}
            handleClose={`/work/projects/${project_slug}/bookmarks`}
          />
        </div>
      )}
    </div>
  );
}
